import axios from 'axios';
import { apiPaths } from 'constants/path';
import { tokenHeader } from 'functions/apiFunctions';
import { IDHospitalApi, AddAndDeleteDoctorRqData, IDUserListApi } from 'models/DCK/DCKApiTypes';

class HospitalSettingApi {
    async addDoctor(rqData: AddAndDeleteDoctorRqData, token: string): Promise<IDHospitalApi> {
        try {
            const response = await axios.post(apiPaths.addDoctor, rqData, {
                headers: tokenHeader(token),
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async deleteDoctor(rqData: AddAndDeleteDoctorRqData, token: string): Promise<IDHospitalApi> {
        try {
            const response = await axios.post(apiPaths.removeDoctor, rqData, {
                headers: tokenHeader(token),
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async GetReadByHospitalId(url: string, token: string): Promise<IDUserListApi> {
        try {
            const response = await axios.get(apiPaths.GetReadByHospitalId + url, {
                headers: tokenHeader(token),
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async UserChangeLevel(rqData: { _id: string; level: number }, token: string): Promise<IDUserListApi> {
        try {
            const response = await axios.put(apiPaths.changeUserLevel, rqData, {
                headers: tokenHeader(token),
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export const hospitalSettingApi = new HospitalSettingApi();
